/* eslint-disable react/prop-types */
import React, {useState} from "react";

import Button from 'components/Button'
import {FixedRating} from "components/Rating";
import {useNavigate} from "react-router-dom";
import {formatCurrency} from 'utils/functions'
import {
    ContainerHotel,
    ContainerPrice,
    ContentHotel,
    HotelImages,
    InformationHotel
} from "./styles";
import {ModalApp} from "../Modal";
import Map from "../Map";
import {useApp} from "../../contexts/AppContext";
import {changeSelectedHotelAction, changeSelectedRoomHotelAction} from "../../contexts/reducers/hotels/actions";
import {FiMapPin} from "react-icons/fi";
import {HiOutlineCurrencyDollar} from "react-icons/hi";

export const BoxHotel = ({data}) => {
    const [open, setOpen] = useState(false)

    const navigate = useNavigate()

    const { hotelState, hotelDispatch } = useApp()
    const { offersHotel } = hotelState

    const price = data.rooms[0]?.amount.BRL
    const points = data.rooms[0]?.amount.WL

    const coords = {
        lat: JSON.parse(data.address.latitude),
        lng: JSON.parse(data.address.longitude),
    }

    const selected = {
        name: data.name,
        show: true
    }

    const externalProperties = JSON.parse(data?.rooms[0]?.externalProperties)

    const handleSelectHotel = () => {
        hotelDispatch(changeSelectedHotelAction(data))
        hotelDispatch(changeSelectedRoomHotelAction({}))
        navigate(`/loja/hotel`)
    }

    const handleModal = () => setOpen(!open)

    return (
        <ContainerHotel>
            <div className="d-flex">
                <div className="image">
                    <HotelImages src={ data.images[0]?.url } alt={ data.name } />
                </div>
                <InformationHotel>
                    <ContentHotel>
                        <p className="title-hotel">{ data.name }</p>
                        <div className="stars">
                            <FixedRating value={ data.stars } size="small" />
                        </div>
                        <p className="info">
                            <HiOutlineCurrencyDollar size={"1.5em"} />
                            { externalProperties["Refundable"] === "True"
                             ?  'Com Reembolso' : 'Sem Reembolso' }
                        </p>

                        <p className="mapa" role="button" onClick={handleModal}>
                            <FiMapPin/> VER LOCALIZAÇÃO
                        </p>

                    </ContentHotel>
                    <ContainerPrice>
                        <p className="daily mt-2">diárias a partir de</p>

                        { offersHotel === "cash" && <p className="price"> { formatCurrency(price) } </p> }
                        { offersHotel === "points" && <p className="price">{ parseFloat(points).toLocaleString() } <span>Pts</span></p> }

                        <p className="taxa">taxas inclusas</p>
                    </ContainerPrice>

                    <div className="d-flex justify-content-center mt-2 mb-1">
                        <Button width="160px" onClick={ handleSelectHotel }>CONTINUAR</Button>
                    </div>
                </InformationHotel>
            </div>

            <ModalApp show={open} handleModal={handleModal} isMap={true}>
                <Map params={coords} selected={selected} />
            </ModalApp>
        </ContainerHotel>
    )
}
